import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '@/App.css';

const NotFound = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    const isAndroid = /android/i.test(userAgent);
    const isIOS =
      /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isAndroid) {
      window.location.replace(
        'https://play.google.com/store/apps/details?id=com.gotoecomapp'
      );
    } else if (isIOS) {
      window.location.replace(
        'https://apps.apple.com/in/app/gotoecom/id6743615043'
      );
    } else {
      window.location.replace('/');
    }
  }, []);

  return (
    <main style={{ textAlign: 'center', padding: '2rem' }}>
      <h2>Redirecting...</h2>
      <p>
        If you're not redirected, <Link to="/">go to homepage</Link>.
      </p>
    </main>
  );
};

export default NotFound;
